import { BuildEnvironment } from '@/models/TriggerParams';

import { BuildConfigurationType } from '../types';
import getBuildParams from './getBuildParams';

const quote = (value: string) => `'${value.replace(/'/g, `'\\''`)}'`;

const envFlagValue = (environments: BuildEnvironment[]) =>
  JSON.stringify(
    Object.fromEntries(
      environments.map(({ isExpand, key, value }) => [key, isExpand ? value : { is_expand: false, value }]),
    ),
  );

const getCliCommand = (appSlug: string, data: BuildConfigurationType): string => {
  const {
    branch,
    commitHash,
    commitMessage,
    environments,
    licensePoolId,
    machineTypeId,
    pipelineId,
    priority,
    stack,
    tag,
    workflowId,
  } = getBuildParams(data);

  const flags: [string, string | number][] = [['--app', appSlug]];

  if (workflowId) {
    flags.push(['--workflow', workflowId]);
  }
  if (pipelineId) {
    flags.push(['--pipeline', pipelineId]);
  }
  if (branch) {
    flags.push(['--branch', branch]);
  }
  if (tag) {
    flags.push(['--tag', tag]);
  }
  if (commitHash) {
    flags.push(['--commit-hash', commitHash]);
  }
  if (commitMessage) {
    flags.push(['--commit-message', commitMessage]);
  }
  if (environments?.length) {
    flags.push(['--env', envFlagValue(environments)]);
  }
  if (stack) {
    flags.push(['--stack', stack]);
  }
  if (machineTypeId) {
    flags.push(['--machine-type', machineTypeId]);
  }
  if (licensePoolId) {
    flags.push(['--license-pool', licensePoolId]);
  }
  if (priority !== undefined) {
    flags.push(['--priority', priority]);
  }

  return [
    'bitrise build trigger',
    ...flags.map(([flag, value]) => `  ${flag} ${typeof value === 'number' ? value : quote(value)}`),
    // Not a build parameter: it keeps the terminal on the build the dialog would have shown.
    '  --watch',
  ].join(' \\\n');
};

export default getCliCommand;
